import React from 'react';
import styles from './style.module.css';

const StatusSelector = ({ selectedStatus, setSelectedStatus }) => {
  const statuses = ['NORMAL', 'FAIL', 'PENDING'];

  const handleChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  return (
    <div className={styles.status_selector}>
      {statuses.map((status) => (
        <label key={status} className={styles.status_selector__option}>
          <input
            type="radio"
            value={status}
            checked={selectedStatus === status}
            onChange={handleChange}
            className={styles.status_selector__input}
          />
        </label>
      ))}
    </div>
  );
};

export default StatusSelector;
